import { Cart, Coaches, Home, Result } from "../pages";
import CoachInfo from "../pages/CoachInfo";
import Faq from "../pages/Faq";
import Guide from "../pages/Guide";
import News from "../pages/News";
import NewsDetail from "../pages/NewsDetail";
import Page403 from "../pages/Page403";
import Profile from "../pages/Profile";
import Record from "../pages/Record";
import RecordDetail from "../pages/RecordDetail";
import Refund from "../pages/Refund";

// navType { hideHeader, hideFooter }
const RouterList = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "*",
    name: "403",
    component: Page403,
  },
  // {
  //   path: "/signin",
  //   name: "signin",
  //   component: Signin,
  //   navType: {
  //     hideHeader: true,
  //     hideFooter: true,
  //   },
  // },
  // {
  //   path: "/signup",
  //   name: "signup",
  //   component: Signup,
  //   navType: {
  //     hideHeader: true,
  //     hideFooter: true,
  //   },
  // },
  {
    path: "/trainers",
    name: "coaches",
    component: Coaches,
  },
  {
    path: "/trainers/info/:id",
    name: "coachInfo",
    component: CoachInfo,
  },
  {
    path: "/search",
    name: "search",
    component: Result,
  },
  {
    path: "/cart",
    name: "cart",
    component: Cart,
  },
  {
    path: "/faq",
    name: "faq",
    component: Faq,
  },
  {
    path: "/news",
    name: "news",
    component: News,
  },
  {
    path: "/news/detail/:id",
    name: "newsDetail",
    component: NewsDetail,
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
  },
  // {
  //   path: "/design",
  //   name: "design",
  //   component: Design,
  // },
  {
    path: "/guide",
    name: "guide",
    component: Guide,
  },
  {
    path: "/record",
    name: "record",
    component: Record,
  },
  {
    path: "/record/detail/:id",
    name: "recordDetail",
    component: RecordDetail,
  },
  {
    path: "/refund",
    name: "refund",
    component: Refund,
  },
  {
    path: "/yuzawa-ski",
    name: "yuzawaSki",
    component: NewsDetail,
  },
  {
    path: "/hoshino-ski",
    name: "hoshinoSki",
    component: NewsDetail,
  },
  {
    path: "/rusutsu-ski",
    name: "rusutsuSki",
    component: NewsDetail,
  },
  {
    path: "/teine-ski",
    name: "teineSki",
    component: NewsDetail,
  },
  {
    path: "/onze-ski",
    name: "onzeSki",
    component: NewsDetail,
  },
];
export default RouterList;
